import { ModalDataWithoutIssues } from '../../../../typings'

export const useButtonClassName = (data: ModalDataWithoutIssues) => {
  const { payload, orderStep, pairedOrderStepUnassigned } = data

  return {
    type: payload.paired && orderStep ? (orderStep.type === 'p' ? 'pickup' : 'dropoff') : '',
    suffix: pairedOrderStepUnassigned ? '__pairedUnassigned' : '',
  }
}
